export default {
  title: 'Baixar SOSAFE',
  description: 'Vamos cuidar uns dos outros. Quanto mais formos, mais seguros estaremos!',
  googlePlayButton: 'Baixe no Google Play',
  appGalleryButton: 'Baixe na AppGallery',
};
